import { Typography } from '@material-ui/core'

import { ProformaStatus } from '../../types/walletEnums'
import useStyles from './styles/StatusBox.styles'

interface BookingListAddFilterButtonProps {
  status: ProformaStatus
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  const getColorForStatus = (s: ProformaStatus) => {
    switch (s) {
      case 'paid':
        return 'green'
      case 'cancelled':
        return 'lightYellow'
      case 'rejected':
        return 'red'
      case 'confirmed':
        return 'blue'
      case 'pendingConfirmation':
        return 'lightBlue'
      case 'pendingPayment':
      case 'pendingPaymentConfirmation':
        return 'lightGreen'
      case 'expired':
        return 'lightGrey'

      default:
        break
    }
  }
  return (
    <div className={classes.root}>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.red].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.green].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}

      {getColorForStatus(status) === 'lightBlue' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightBlue].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightYellow' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightYellow].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightGrey' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightGrey].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightGreen' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightGrey].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'blue' ? (
        <Typography
          variant="body1"
          className={[classes.text, classes.lightGrey].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
